import "core-js/modules/web.dom.iterable";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
export const newRelicCall = (_ref) => {
  let {
    msg,
    level,
    customFilter
  } = _ref;

  if (process.client && window && window.newrelic) {
    let newRelicMessage = msg;

    if (typeof message === 'object') {
      newRelicMessage = JSON.stringify(msg);
    }

    window.newrelic.noticeError(newRelicMessage, _objectSpread({
      'mdm-errors': 'mdm-errors',
      'log-level': level || 'error',
      'mdm-console': level || 'error'
    }, customFilter && {
      'custom-filter': customFilter
    }));
  }
};
export const transformArgumentsToString = args => Object.values(args).map(arg => typeof arg === 'object' ? JSON.stringify(arg) : arg).join(' ');
export const logError = (_ref2) => {
  let {
    msg
  } = _ref2;
  newRelicCall({
    msg
  });
  console.error(msg);
};